import React from "react";
import TextField from "../../../../Forms/TextField";
import TextCKEditor from "../../../../Forms/TextCKEditor";
import { Text } from "@fluentui/react";
import { useFormikContext } from "formik";

const OpenTextQuestionFields = () => {
  const { getFieldProps, setFieldValue } = useFormikContext();
  return (
    <>
      <TextField
        label="User Facing Action Title"
        name="questionActionTitle"
        description="Shown on the collapsed checklist card. Max 75 characters."
        required
      />

      <div>
        <label className="default-label">Question</label>
        <Text
          variant="xSmall"
          styles={{ root: { color: "#605e5c", display: "block", marginBottom: 4 } }}
        >
          (supports HTML formatting)
        </Text>
        <TextCKEditor
          value={getFieldProps("questionText").value || ""}
          onChange={(val) => setFieldValue("questionText", val)}
        />
        <Text variant="xSmall">
          This is the question the learner answers after expanding the action item.
        </Text>
      </div>

      <div>
        <label className="default-label">Help Text</label>
        <Text
          variant="xSmall"
          styles={{ root: { color: "#605e5c", display: "block", marginBottom: 4 } }}
        >
          (optional, supports HTML formatting)
        </Text>
        <TextCKEditor
          value={getFieldProps("questionHelpText").value || ""}
          onChange={(val) => setFieldValue("questionHelpText", val)}
        />
        <Text variant="xSmall">
          Optional guidance shown under the question. Responses are limited to 2000 characters.
        </Text>
      </div>
    </>
  );
};

export default OpenTextQuestionFields;
